import {
  publicBlogPostQueryOptions,
  publicBlogPostsQueryOptions,
  publicPageQueryOptions,
} from "./publicContentQueries";

export const getPageSlugFromPath = (pathname) => {
  if (pathname === "/") return "home";
  if (pathname === "/about") return "about";
  if (pathname === "/law") return "law";
  if (pathname === "/news") return "news";
  if (pathname === "/report/submitted") return "report-submitted";
  if (pathname === "/report") return "report";
  if (pathname === "/track") return "track";

  const newsMatch = pathname.match(/^\/news\/([^/]+)$/);
  if (newsMatch) {
    return { type: "blogPost", id: newsMatch[1] };
  }

  return null;
};

export const prefetchPublicRoute = (queryClient, pathname, language) => {
  const target = getPageSlugFromPath(pathname);
  if (!target) return;

  if (typeof target === "object" && target.type === "blogPost") {
    queryClient.prefetchQuery(publicBlogPostQueryOptions(target.id, language));
    return;
  }

  queryClient.prefetchQuery(publicPageQueryOptions(target, language));

  if (target === "news") {
    queryClient.prefetchQuery(publicBlogPostsQueryOptions(language));
  }

  if (target === "home") {
    queryClient.prefetchQuery(
      publicBlogPostsQueryOptions(language, { home: true, take: 3 })
    );
  }
};
